/** Import modules */

import { gql } from "@apollo/client";

const 

/** Tyres collection */

TyresCatalog = gql`query productQuery ( 
    
    $first                  : Int, 
    
    $last                   : Int, 
    
    $after                  : String, 
    
    $before                 : String, 
    
    $width                  : [Float!], 
    
    $height                 : [Float!], 
    
    $diameter               : [String!] 
    
    $manufacturer           : [String!], 
    
    $season                 : [String!], 

    $speedRating            : [String!],

    $specifications         : [String!],

    $loadIndex              : [String!],

    $noiseIndex             : [String!],

    $wetBreakingEfficiency  : [String!],

    $fuelEfficiency         : [String!],

    $vehicleType            : [String!],

    $upperPriceRange        : Int,

    $lowerPriceRange        : Int,
    
    $sortOrder              : String,
    
    $showSingles            : Boolean,

    $studs                  : [StudsEnum!],
    
    $showSet                : Boolean,

    $availability           : [AvailabilityTypeEnum!],

    $isCTire                : Boolean,

    $runFlat                : Boolean
    
    ) {
    
        multiFieldProductSearch ( 
        
            first                   : $first, 
            
            last                    : $last, 
            
            productType             : "tire", 
        
            after                   : $after, 
        
            before                  : $before, 
        
            width                   : $width, 
        
            height                  : $height, 
        
            diameter                : $diameter, 
            
            manufacturer            : $manufacturer, 
            
            season                  : $season, 

            speedRating             : $speedRating,

            specifications          : $specifications,

            loadIndex               : $loadIndex,

            noiseIndex              : $noiseIndex,

            wetBreakingEfficiency   : $wetBreakingEfficiency,

            fuelEfficiency          : $fuelEfficiency,

            vehicleType             : $vehicleType,

            upperPriceRange         : $upperPriceRange,

            lowerPriceRange         : $lowerPriceRange,
            
            sortOrder               : $sortOrder,

            showSingles             : $showSingles,

            studs                   : $studs,

            showSet                 : $showSet,

            availability            : $availability,

            isCTire                 : $isCTire,

            runFlat                 : $runFlat
            
        ) { 
            
        edges { 
            
            node {

                id

                awsImageUrl

                currentImage

                width

                height

                diameter

                model

                loadIndex

                noiseIndex

                speedRating

                season

                productVendors {

                    price
          
                    qty 
                    
                    qtyDays
                    
                    qtyHour
                    
                    qtyWeeks

                }

                manufacturer { name }

                wetBreakingEfficiency

                fuelEfficiency

                specifications

                vehicleType

                priceList

                productType

                isCTire

                year

                runFlat

                studs

            } 
    
        }
            
        pageInfo { 
            
            hasNextPage 
            
            hasPreviousPage 
            
            startCursor 
            
            endCursor 
        
        }

        totalPages

        totalCount

    }

}`,

/** Single product */

SingleProduct = gql`query SingleProductQuery ( $id: [ID!]! ) { product ( id: $id ) { 

    edges { node {

        id

        productType

        awsImageUrl

        currentImage

        model

        width

        height

        diameter

        loadIndex

        speedRating

        loadIndex

        noiseIndex

        season

        description

        productVendors {

            price
            
            qty 
            
            qtyDays
            
            qtyHour
            
            qtyWeeks

        }

        manufacturer { name }

        vehicleType

        wetBreakingEfficiency

        fuelEfficiency

        specifications

        priceList

        isCTire

        studs

    } }
          
} }`,

/** @module STUDS_ENUM */

STUDS_ENUM = gql`query introspectTaskStateEnumType {

    __type ( name: "StudsEnum" ) {

        enumValues {

            name

        }

    }

}`,

/** Tyre filter attributes */

FilterAttributes = gql`query { searchAttributes }`,

/** Winter tyre size combinations */

WinterTyreSizes = gql`query ( $manufacturer: [String!], $studs: [StudsEnum!] ) {

    winterTyreSizes ( manufacturer: $manufacturer, studs: $studs )

}`,

/** Winter tyre manufacturers */

WinterTyreManufacturers = gql`query (

    $width: [Float!],

    $height: [Float!],

    $diameter: [String!]

    ,

    $studs: [StudsEnum!]

) {

    winterTyreManufacturers (

        width: $width,

        height: $height,

        diameter: $diameter

        ,

        studs: $studs

    )

    }`,

    /** Winter tyre stud statuses */

    WinterTyreStuds = gql`query (

        $width: [Float!],

        $height: [Float!],

        $diameter: [String!],

        $manufacturer: [String!]

    ) {

        winterTyreStuds (

            width: $width,

            height: $height,

            diameter: $diameter,

            manufacturer: $manufacturer

        )

    }`,

/** Winter tyre price bounds */

WinterTyrePriceBounds = gql`query (

    $width: [Float!],

    $height: [Float!],

    $diameter: [String!],

    $manufacturer: [String!],

    $availability: [AvailabilityTypeEnum!]

    ,

    $studs: [StudsEnum!]

) {

    winterTyrePriceBounds (

        width: $width,

        height: $height,

        diameter: $diameter,

        manufacturer: $manufacturer,

        availability: $availability

        ,

        studs: $studs

    )

}`;

/** Export queries */

export { 
    
    TyresCatalog, 
    
    FilterAttributes, 

    WinterTyreSizes,

    WinterTyreManufacturers,

    WinterTyreStuds,

    WinterTyrePriceBounds,

    SingleProduct,

    STUDS_ENUM

};